import {useState, useRef, useEffect} from 'react';
// ** Reactstrap Imports
import { Row, Col, Card, CardBody, Form, Label, Input, Button } from 'reactstrap';
import { useNavigate, useParams } from 'react-router-dom';

import axios from 'axios';
import { toast } from 'react-toastify';
import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats } from "../../utils/EditorToolbar";
import 'react-quill/dist/quill.snow.css';
import useAuth from '../../hooks/useAuth';

const EditAbout = () => {
  const { auth } = useAuth();

  const navigate = useNavigate();
  const {id} = useParams();

  const [aboutInfo, setAboutInfo] = useState({})
  const [aboutTagLine, setAboutTagline] = useState()
  const [isEditMode, setIsEditMode] = useState(false);


  const fileInputRef = useRef();
  const [aboutImg, setAboutImg] = useState(null)

  const [mykey, setMyKey] = useState('')
  const ondescription = (value) => {
    setAboutInfo((prev) => {
      return {
        ...prev,
        aboutDesc:value
      }
    })
    
  } 


  const convertToBase64 = file => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      if (!file) {
        alert("please select an image")
      }else {
        fileReader.readAsDataURL(file);
        fileReader.onload = () => {
          resolve(fileReader.result)
        }
      }
      fileReader.onerror = error => {
          reject(error)
      }
    })
  }


  const addImage = async (e) => {
    setIsEditMode(true);
    const file = e.target.files[0];
    const base64Img = await convertToBase64(file);
    fileInputRef.current.value = base64Img;
    setAboutImg(e.target.files[0]);
  };

  const getData = async () => {
          try {
            const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/abouts/find-about/${id}`, {
                headers: {
                    'Authorization': 'Bearer ' + auth.accessToken
                }
            })
          
            setAboutInfo(res.data);
            setAboutTagline(res.data.aboutTagLine);

        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
        }
      }
    

    useEffect(() => {
      getData();
    },[id])

    // ** States
   let initialState = aboutInfo;


    const handleChange = (event) => {
        const { value, name } = event.target
        setAboutInfo(prevValue => {
            return({
                ...prevValue,
                [name]: value
            })
        });
    }

    const handleUpdateClick = async (event) => {
        event.preventDefault();

        let aboutTagLine = aboutInfo.aboutTagLine;
        let aboutDesc = aboutInfo.aboutDesc;

        const formData = new FormData();
        formData.append('aboutTagLine', aboutTagLine);
        formData.append('aboutDesc', aboutDesc);
        formData.append('aboutImg', aboutImg);


        try {
            const res = await axios.put(`${process.env.REACT_APP_API_BASE_URL}/abouts/update-about/${id}`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'Bearer ' + auth.accessToken
                }
            })
            toast.success(res.data.message, {
                className: "success-toast",
                autoClose: 3000,
                position: toast.POSITION.BOTTOM_RIGHT
            })
            navigate('/about/view')


        } catch (error) {
          error.response.data.message ? toast.error(error.response.data.message, {
            className: "error-toast",
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000
            }) :  toast.error(error.response.data.error, {
              className: "error-toast",
              position: toast.POSITION.BOTTOM_RIGHT,
              autoClose: 3000
          })
            
        }
    }


    const handleReset = async (event) => {
      event.preventDefault();
      navigate('/about/view')
    }
 
  return (
    <div className="container">
      <Row sm="12">
        <h5 className="sec-header">Edit about</h5>
      </Row> 
      <Row sm='12'>
        <Card>
            <CardBody>
            
          <Col sm='12' className='mb-2'>
          <Form>
            
            <div className='mb-1'>
              <Label className='form-label' for='title'>
                About Tagline <span className='text-danger'>*</span>
              </Label>
              <Input
                id='title'
                type='text'
                className='me-1'
                name='aboutTagLine'
                minLength={20}
                maxLength={90}
                required={true}
                value={aboutInfo.aboutTagLine || aboutTagLine}
                onChange={handleChange}
                
              />

            </div>

            <div className='mb-1'>
              <Label className='form-label' for='title'>
                About Description <span className='text-danger'>*</span>
              </Label>
              <EditorToolbar toolbarId={'t1'} />
              <ReactQuill 
                theme="snow"                    
                value={aboutInfo.aboutDesc}
                onChange={ondescription}                 
                placeholder={"Write something awesome..."}
                modules={modules('t1')}
                formats={formats}
              />
            </div>

          
            <div className='mb-1'>
              <Label className='form-label' for='title'>
                Image <span className='text-danger'>*</span>
              </Label>
              <Input
                id='aboutImg'
                type='file'
                className='me-1'
                name='aboutImg'
                accept='image/png, image/jpeg, image/jpg'
                required={true}
                key={mykey || ''}
                ref={fileInputRef} onChange={addImage}
              />
            </div>

            {isEditMode  ?  <div className='mb-3 mt-3'>
             
             <div>
             <img
                style={{width: 180}}
                src={fileInputRef && fileInputRef.current &&  fileInputRef.current.value || ''} />
             </div>
           </div> : <div className='mb-3 mt-3'>
             <div>   
             {
              aboutInfo.aboutImg &&  <img style={{width: 250}} src={`${process.env.REACT_APP_API_IMAGE_URI.substring(0, process.env.REACT_APP_API_IMAGE_URI.indexOf("/api"))
               + aboutInfo.aboutImg.substring(aboutInfo.aboutImg.indexOf("/uploads"))}`} alt="about-img"></img>
             }            
            
             </div>
          </div>}
           
            {/* {aboutImg  ?  <div className='mb-3 mt-3'>
             
              <div>
              <img
                 style={{width: 180}}
                 src={fileInputRef.current.value || ''} />
              </div>
            </div> : <div className='mb-3 mt-3'>
              <div>   
              {
                aboutInfo.aboutImg &&  <img style={{width: 250}} src={`${process.env.REACT_APP_API_IMAGE_URI.substring(0, process.env.REACT_APP_API_IMAGE_URI.indexOf("/api"))
               + aboutInfo.aboutImg.substring(aboutInfo.aboutImg.indexOf("/uploads"))}`} alt="about-img"></img>
              }            
             
              </div>
           </div>} */}

            <Row className='pt-2'>
              <Col>
              <div className='mb-1'>
                <Button
                  block
                  color="success"
                  type='submit'
                  onClick={event => handleUpdateClick(event)}
                >
                  Update
                </Button>
              </div>
          
              </Col>
              <Col>
                <div className='mb-1'>
                  <Button
                    block
                    color="warning"
                    onClick={event => handleReset(event)}
                  >
                    Cancel & Go to List
                  </Button>
                </div>         
              </Col>
            </Row>
          </Form>
            
          </Col>
          </CardBody>
        </Card>
          
      </Row>
    </div>
  );
};

export default EditAbout;
